import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteVehicleModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "deleteVehicleModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-5 fw-bold mb-3 text-left" }, "Eliminar vehículo")
], -1)
const _hoisted_5 = {
  class: "modal-body scroll-y pt-0",
  style: {"padding-left":"40px"}
}
const _hoisted_6 = {
  class: "row g-9 mb-2",
  style: {"margin-top":"10px"}
}
const _hoisted_7 = { class: "row mb-2 text-start fs-base fw-normal" }
const _hoisted_8 = { class: "row text-end mt-5" }
const _hoisted_9 = { class: "listaButtons" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal",
    type: "button"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Cancelar")
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Eliminar", -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, " ¿Desea eliminar " + _toDisplayString(_ctx.marca) + " " + _toDisplayString(_ctx.modelo) + " " + _toDisplayString(_ctx.anio) + " " + _toDisplayString(_ctx.version) + "? Sus datos serán eliminados y no se podrá deshacer. ", 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteVehicle && _ctx.deleteVehicle(...args)))
                  }, _hoisted_12)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 512))
}